import React from "react";
import "./VerticalCarousel.css";
export const VerticalCarousel = ({ images }) => {
  return (
    <div className="TqLWKQ5WSi pr-zi4fgm" style={{ background: "#232527" }}>
      <div className="pr-1wvi6jk">
        <div style={{ display: "flex", width: "100%", overflow: "hidden", height: "100%" }}>
          {/* Kolumn 1 — scrollar nedåt (bilder kommer ovanifrån) */}
          <div style={{ flex: 1, overflow: "hidden" }}>
            {images.map((data, index) => (
              <div key={index} className="UsiG9bXE2_" style={{ paddingTop: "16px" }}>
                <div className="O1_JKDC4AK BdrF90TR9L uCtpXdkvvj pr-hxaf01">
                  <div className="pr-15o1nmi">
                    <div className="cHORm9q4_D pr-1cpzyzc">
                      <img
                        className="xUAmIg3IAt pr-0"
                        alt="Produktbild"
                        width="160"
                        height="210"
                        src={data.images[0]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* Kolumn 2 — scrollar uppåt (bilder kommer nerifrån) */}
          <div style={{ flex: 1, overflow: "hidden" }}>
            {images.map((data, index) => (
              <div key={index} className="NKJAPDB50i" style={{ paddingTop: "16px" }}>
                <div className="O1_JKDC4AK BdrF90TR9L uCtpXdkvvj pr-hxaf01">
                  <div className="pr-15o1nmi">
                    <div className="cHORm9q4_D pr-1cpzyzc">
                      <img
                        className="xUAmIg3IAt pr-0"
                        alt="Produktbild"
                        width="160"
                        height="210"
                        src={data.images[1]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* Kolumn 3 — scrollar nedåt (bilder kommer ovanifrån) */}
          <div style={{ flex: 1, overflow: "hidden" }}>
            {images.map((data, index) => (
              <div key={index} className="UsiG9bXE2_" style={{ paddingTop: "16px" }}>
                <div className="O1_JKDC4AK BdrF90TR9L uCtpXdkvvj pr-hxaf01">
                  <div className="pr-15o1nmi">
                    <div className="cHORm9q4_D pr-1cpzyzc">
                      <img
                        className="xUAmIg3IAt pr-0"
                        alt="Produktbild"
                        width="160"
                        height="210"
                        src={data.images[2]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};